import React from "react";
import { Form, Col, Container, Row } from "react-bootstrap";
import PostcodeInput from "../Common/PostcodeInput";

const DhlBranchFilters = ({ onFilterChange, onSearch, filters = {} }) => {
  return (
    <Container className="mt-4">
      <Form onKeyDown={(e) => { if (e.key === 'Enter' && !['TEXTAREA', 'SELECT'].includes(e.target.tagName)) { e.preventDefault(); onSearch?.(); } }}>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group controlId="ex">
              <Form.Label>Terminal EX</Form.Label>
              <Form.Control
                type="text"
                placeholder="EX..."
                value={filters.ex || ""}
                onChange={(e) => onFilterChange("ex", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="dr">
              <Form.Label>Terminal DR</Form.Label>
              <Form.Control
                type="text"
                placeholder="DR..."
                value={filters.dr || ""}
                onChange={(e) => onFilterChange("dr", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="postcodesText">
              <Form.Label>Kod pocztowy</Form.Label>
              <PostcodeInput
                value={filters.postcodesText || ""}
                onChange={(val) => onFilterChange("postcodesText", val)}
                  inputMode="numeric"
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default DhlBranchFilters;
